import React from 'react';
import { Link } from 'react-router-dom';
import './css/EmptyPage.scss';

function ErrorPage({ error, errorInfo }) {
  return (
    <div id="EmptyPage" className="empty-page">
      <div className="empty-page_container">
        <img
          src={require('../../assets/images/icon/ico_emptyPage.svg').default}
          alt="경고 아이콘 이미지"
          className="empty-page_img"
        />
        <h2 className="empty-page_title">{error && error.toString()}</h2>
        <p className="empty-page_text">{errorInfo && errorInfo.componentStack}</p>
        <Link to="/" className="empty-page_btn">
          메인페이지로 돌아가기
        </Link>
      </div>
    </div>
  );
}

export default ErrorPage;
